import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LabelPrintService {
  // private apiUrl = "http://localhost:3003/api/labelPrint";
   private apiUrl = "https://lexipackghana.com:3003/api/labelPrint";

  constructor(private http: HttpClient) {}
  addLabelPrint(data:any){
    return this.http.post(this.apiUrl+'/addLabel',data);
  }
  getLabelPrint(){
    return this.http.get(this.apiUrl+'/getAllLabel');
  }
  getLabelPrintById(id: string) {
    return this.http.get(this.apiUrl + '/' + id);
  }
  updateLabelPrint(id: string, data: any) {
    return this.http.put(this.apiUrl + '/' + id, data);
  }



  // printLabel(id: any) {
  //   return this.http.post(this.apiUrl + '/printLabel/' + id, {}, {
  //     responseType: 'blob'
  //   });
  // }

  printLabel(id: string) {
    return this.http.post(this.apiUrl + '/printLabel/' + id, {}, {
      responseType: 'blob'
    });
  }
  
  
}
